var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodMorning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    "data-name": "Rectangle 1783",
    width: 40,
    height: 40,
    transform: "translate(-21556 -17132)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_46",
    "data-name": "Mask Group 46",
    transform: "translate(21556 17132)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sunrise",
    transform: "translate(-21556 -17132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17726",
    "data-name": "Group 17726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9830",
    "data-name": "Path 9830",
    d: "M38.23,15.014a19.146,19.146,0,0,0-36.461,0L5.058,29.3H34.942Z",
    fill: "#00adf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17727",
    "data-name": "Group 17727"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 15.625,
    cy: 15.625,
    r: 15.625,
    transform: "translate(4.375 4.063)",
    fill: "#009cf2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17728",
    "data-name": "Group 17728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9831",
    "data-name": "Path 9831",
    d: "M38.844,24.236a19.264,19.264,0,0,0-.613-9.221,4,4,0,0,0-2.666,5.922,2.508,2.508,0,0,0-1.719,2.348,1.846,1.846,0,1,0-1.08,3.344H37Z",
    fill: "#e6f8fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17729",
    "data-name": "Group 17729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9832",
    "data-name": "Path 9832",
    d: "M1.156,24.236a19.264,19.264,0,0,1,.613-9.221,4,4,0,0,1,3.2,3.92,3.98,3.98,0,0,1-.537,2,2.509,2.509,0,0,1,1.719,2.348,1.846,1.846,0,1,1,1.08,3.344H3Z",
    fill: "#e6f8fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17734",
    "data-name": "Group 17734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17730",
    "data-name": "Group 17730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9833",
    "data-name": "Path 9833",
    d: "M31.529,11.419a2.08,2.08,0,0,1-1-3.748A1.087,1.087,0,0,0,29.444,5.8,2.08,2.08,0,0,1,26.7,3.056a1.087,1.087,0,0,0-1.872-1.081,2.08,2.08,0,0,1-3.748-1,1.087,1.087,0,0,0-2.161,0,2.08,2.08,0,0,1-3.748,1A1.087,1.087,0,0,0,13.3,3.056,2.08,2.08,0,0,1,10.556,5.8,1.087,1.087,0,0,0,9.475,7.671a2.08,2.08,0,0,1-1,3.748,1.087,1.087,0,0,0,0,2.161,2.08,2.08,0,0,1,1,3.748A1.087,1.087,0,0,0,10.556,19.2,2.08,2.08,0,0,1,13.3,21.944a1.087,1.087,0,0,0,1.872,1.081,2.08,2.08,0,0,1,3.748,1,1.087,1.087,0,0,0,2.161,0,2.08,2.08,0,0,1,3.748-1A1.087,1.087,0,0,0,26.7,21.944,2.08,2.08,0,0,1,29.444,19.2a1.087,1.087,0,0,0,1.081-1.872,2.08,2.08,0,0,1,1-3.748,1.087,1.087,0,0,0,0-2.161Z",
    fill: "#fff442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17731",
    "data-name": "Group 17731"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 8.523,
    cy: 8.523,
    r: 8.523,
    transform: "translate(11.477 3.977)",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17732",
    "data-name": "Group 17732"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 2.28,
    cy: 2.28,
    r: 2.28,
    transform: "translate(21.029 6.91)",
    fill: "#fff442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17733",
    "data-name": "Group 17733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9834",
    "data-name": "Path 9834",
    d: "M15.455,12.5a8.526,8.526,0,0,1,6.534-8.289,8.523,8.523,0,1,0,0,16.578A8.526,8.526,0,0,1,15.455,12.5Z",
    fill: "#fdca00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17735",
    "data-name": "Group 17735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9835",
    "data-name": "Path 9835",
    d: "M2.9,29.475l2.127,2.638H34.969L37.1,29.475a19.005,19.005,0,0,0,1.748-5.24c-2.1.124-2.2,1.553-4.488,1.553-2.393,0-2.393-1.562-4.785-1.562s-2.393,1.563-4.785,1.563S22.392,24.226,20,24.226s-2.392,1.563-4.785,1.563-2.392-1.562-4.785-1.562-2.393,1.563-4.785,1.563c-2.289,0-2.389-1.429-4.488-1.553A19,19,0,0,0,2.9,29.475Z",
    fill: "#5ccbf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17736",
    "data-name": "Group 17736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9836",
    "data-name": "Path 9836",
    d: "M20,28.914a2.344,2.344,0,0,1,0-4.687h0c-2.392,0-2.392,1.563-4.785,1.563s-2.392-1.562-4.785-1.562-2.393,1.563-4.785,1.563c-2.289,0-2.389-1.429-4.488-1.553A19,19,0,0,0,2.9,29.475l2.127,2.638H20Z",
    fill: "#2ebcf6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17737",
    "data-name": "Group 17737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9837",
    "data-name": "Path 9837",
    d: "M7.028,34.933,10.7,36.425H29.3l3.668-1.491A19.21,19.21,0,0,0,37.1,29.475a4.383,4.383,0,0,1-2.74,1c-2.393,0-2.393-1.562-4.785-1.562s-2.393,1.563-4.785,1.563S22.392,28.914,20,28.914s-2.392,1.563-4.785,1.563-2.392-1.562-4.785-1.562-2.393,1.563-4.785,1.563a4.382,4.382,0,0,1-2.74-1,19.209,19.209,0,0,0,4.124,5.458Z",
    fill: "#8adaf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17738",
    "data-name": "Group 17738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9838",
    "data-name": "Path 9838",
    d: "M20,33.6a2.344,2.344,0,0,1,0-4.687h0c-2.392,0-2.392,1.563-4.785,1.563s-2.392-1.562-4.785-1.562-2.393,1.563-4.785,1.563a4.382,4.382,0,0,1-2.74-1,19.21,19.21,0,0,0,4.124,5.458L10.7,36.425H20Z",
    fill: "#5ccbf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17739",
    "data-name": "Group 17739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9839",
    "data-name": "Path 9839",
    d: "M32.972,34.933c-1.148-.435-1.588-1.332-3.4-1.332-2.393,0-2.393,1.563-4.785,1.563S22.392,33.6,20,33.6s-2.392,1.563-4.785,1.563S12.822,33.6,10.43,33.6c-1.813,0-2.253.9-3.4,1.332a19.137,19.137,0,0,0,25.943,0Z",
    fill: "#b8e9fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9840",
    "data-name": "Path 9840",
    d: "M7.028,34.933a19.143,19.143,0,0,0,6.213,3.838,2.343,2.343,0,0,1,1.973-3.608c-2.392,0-2.392-1.562-4.785-1.562-1.813,0-2.253.9-3.4,1.332Z",
    fill: "#8adaf9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodMorning);
export default __webpack_public_path__ + "static/media/Good-morning.d0c1851adfba35a6f560e7fb5b5331bd.svg";
export { ForwardRef as ReactComponent };